// extracted by mini-css-extract-plugin
export default {"delete":"ListHelp_delete__RvPJF","table_help":"ListHelp_table_help__yxidM"};